import AuthenticatedRoute from './ui/AuthenticatedRoute'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import { ConnectionsRoutes, OAuthCallbackRoutes } from 'features/connections/ui/ConnectionsRoutes'
import { MapsRoutes } from 'features/maps'
import { AccountRoutes } from 'features/account'
import { AppsRoutes } from 'features/apps'
import { DevelopersRoutes } from 'features/developers'
import { DataObservatoryRoutes } from 'features/data-observatory'
import { HomeRoutes } from 'features/home'
import BuilderRoutes from 'features/builder/ui/BuilderRoutes'
import { DataExplorerRoutes } from 'features/data-explorer'
import { DataCatalogPrivateRoutes, DataCatalogPublicRoutes } from 'features/spatial-data-catalog'
import { ErrorRoutes } from 'features/errors'
import WorkflowsRoutes from 'features/workflows/ui/WorkflowsRoutes'
import WorkflowEditorRoutes from 'features/workflows/ui/WorkflowEditorRoutes'
import { Main } from 'features/common/ui/AppTemplate'
import { HomePage } from 'features/home/ui/HomePage'
import Logout from 'features/common/ui/AppTemplate/Header/Partials/UserInfo/Logout'
import SnowflakeInAppRoutes from 'features/snowflake-in-app/ui/SnowflakeInAppRoutes'

const DEFAULT_ROUTE = {
  path: '/',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<HomePage />} allowGuestAccess />
    </LazyLoad>
  )
}

const LOGOUT_ROUTE = {
  path: 'logout',
  element: (
    <LazyLoad>
      <Logout />
    </LazyLoad>
  )
}

const routes = [
  {
    path: '/',
    element: (
      <LazyLoad>
        <Main />
      </LazyLoad>
    ),
    children: [
      DEFAULT_ROUTE,
      MapsRoutes,
      WorkflowsRoutes,
      AppsRoutes,
      DevelopersRoutes,
      DataObservatoryRoutes,
      ConnectionsRoutes,
      AccountRoutes,
      HomeRoutes,
      DataExplorerRoutes,
      ...DataCatalogPrivateRoutes
    ]
  },
  SnowflakeInAppRoutes,
  ...OAuthCallbackRoutes,
  ...DataCatalogPublicRoutes,
  ...BuilderRoutes,
  ...WorkflowEditorRoutes,
  ...ErrorRoutes,
  LOGOUT_ROUTE
]

export default routes
